<template>
    <div class="lc">
        <div ref="cmain1" class="cmain" @mouseover="autoTimePaused = true" @mouseout="autoTimePaused = false"></div>
    </div>
</template>

<script>
import * as methods from "./method.js";
export default {
    name: "template.scope71",
    props: {
        vdata: {
            type: [Array, String],
            default: () => [],
        },
        jsondata: {
            type: [Array, String],
            default: () => [],
        },
        scopedata: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            title: "scope9-【组件】饼图联动圆环图样式-完成",
            timer: null,
            defaultdata: [
                {
                    value1: "分类一",
                    value2: "22",
                    value3: [] || "数据",
                    value4: "人",
                },
                {
                    value1: "分类二",
                    value2: "14",
                    value3: [] || "数据",
                },{
                    value1: "分类三",
                    value2: "22",
                    value3: [] || "数据",
                    value5: '山东省'
                },{
                    value1: "小分类一",
                    value2: "12",
                    value3: [] || "数据",
                    value5: '分类一'
                },{
                    value1: "小分类二",
                    value2: "13",
                    value3: [] || "数据",
                    value5: '分类一'
                },{
                    value1: "小分类三",
                    value2: "14",
                    value3: [] || "数据",
                    value5: '分类三'
                },
            ],
            valueMap: [
                { name: "名称", key: "value1" },
                { name: "数值", key: "value2" },
                { name: "单位", key: "value4" },
                { name: "父数据", key: "value5" },
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
            config: {},
            autoTimePaused: false, // 新增变量，用于标记定时器是否暂停
        };
    },
    beforeDestroy() {
        clearInterval(this.timer);
        this.timer = null;
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
                let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
            }
        },
        jsondata(n) {
            this.exceldata = n;
        },
        defaultdata(n) {
            this.DrawEcharts();
        },
    },
    methods: {
        ...methods,
        DrawEcharts() {
            clearInterval(this.timer)
            this.timer = null
            var echarts = require("echarts");
            var TmyChart = echarts.init(this.$refs.cmain1);
            let colorData = ["#008bff", "#04e6e5", "#00e28e", "#a6e7fc"];
            let total = 0;
            let chartdata = []
            this.defaultdata.forEach(item => {
                if (item.value5) {
                    let cindex = chartdata.findIndex(del => del.value1 == item.value5)
                    if (cindex !== -1) {
                        chartdata[cindex].value3.push(item)
                    }
                } else {
                    chartdata.push({...item, value3: []})
                }
            })
            let vdata = chartdata.map((item, i) => {
                total += +item.value2;
                return {
                    name: item.value1,
                    value: +item.value2,
                    cities: item.value3.map((del, i) => {
                        return {
                            name: del.value1,
                            value: +del.value2,
                            itemStyle: { color: colorData[i] },
                        };
                    }),
                    itemStyle: { color: colorData[i] },
                };
            });
            vdata.forEach((item) => {
                item.per = ((item.value / total) * 100).toFixed(1);
            });
            let unit = this.defaultdata[0].value4 || '';
            var Toption = {
                tooltip: {
                    trigger: "item",
                    formatter: "{b}: {c} ({d}%)",
                },
                series: [
                    {
                        name: "内层饼图",
                        type: "pie",
                        radius: ["0%", "50%"],
                        label: {
                            show: true,
                            position: "inside",
                            formatter: "{b}",
                        },
                        itemStyle: {
                            normal: {
                                borderColor: "#000",
                                borderWidth: 2,
                                // color: this.vdata1.itemStyle
                            },
                        },
                        data: vdata.map((item) => item),
                    },
                    {
                        name: "外层环形图",
                        type: "pie",
                        radius: ["60%", "75%"],
                        itemStyle: {
                            normal: {
                                borderColor: "#000",
                                borderWidth: 2,
                                // color: this.vdata1.itemStyle
                            },
                        },
                        data: vdata[0].cities.map((item) => item) || [],
                        label: {
                            color: "#C6D2D8",
                            // padding: [-30, 0, 0, 0,],
                            fontSize: 12,
                            // alignTo: 'edge',
                            formatter: function (params) {
                                // console.log(params, "|l3|");
                                return `${params.data.name}\n ${params.data.value}${unit}`;
                            },
                            minMargin: 20,
                            edgeDistance: 0,
                            lineHeight: 15,
                        },
                        labelLine: {
                            lineStyle: {
                                color: "#748496",
                            },
                            length: 30,
                            length2: 40,
                            maxSurfaceAngle: 80,
                        },
                    },
                ],
            };
            TmyChart.clear();
            Toption && TmyChart.setOption(Toption);
            // 监听鼠标悬停事件
            TmyChart.on("mouseover", (params) => {

                if (params.seriesIndex === 0) {
                    // 悬停在内层饼图
                    const seriesName = params.name;
                    // 根据内层饼图获取对应的外层环形图
                    let relatedData = chartdata
                        .filter((data) => data.value1 === seriesName)[0].value3
                        .map((data, i) => ({
                            name: data.value1,
                            value: data.value2,
                            itemStyle: { color: colorData[i] },
                        }));
                    // 更新外层环形图的数据
                    TmyChart.setOption({
                        series: [
                            {
                                name: "内层饼图",
                                type: "pie",
                                radius: ["0%", "50%"],
                            },
                            {
                                name: "外层环形图",
                                type: "pie",
                                radius: ["60%", "75%"],
                                data: relatedData,
                            },
                        ],
                    });
                }
            });
            this.timer = setInterval(() => {
                if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
                TmyChart.clear();
                Toption && TmyChart.setOption(Toption);
            }, 5000);
        },
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata;
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata;
        }
        this.setData()
        this.DrawEcharts();
    },
};
</script>

<style scoped lang="scss">
.lc {
    width: 435px;
    height: 240px;
    display: flex;
    position: relative;
    padding: 10px 0;
    overflow: hidden;
}

.cmain {
    width: 100%;
    height: 100%;
}
</style>